import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface SnowState {
  snowEnabled: boolean
  setSnowEnabled: (enabled: boolean) => void
}

export const useSnowStore = create<SnowState>()(
  devtools(
    (set) => ({
      snowEnabled: false,
      setSnowEnabled: (enabled: boolean) => set({ snowEnabled: enabled }),
    }),
    {
      name: "snow-effect",
    }
  )
)
